angular.module("munAuthorization.components", []).component("munAuthorization", {
    templateUrl: "ng/components/munAuthorization/munAuthorization.view.html",
    bindings: {
        richiestePostVendita: "<"
    },
    controllerAs: "munAutorizationCtrl",
    controller: function MunAutorization(
        $location,
        $modalService,
        $arcService,
        $RichiestePostVenditaService,
        RichiestePostVendita,
        $rootScope,
        Contratti
    ) {
        var self = this;

        self.$onInit = function () {
            self.supportModel = {
                loading: false,
                restDownloadRunning: false,
                listOfDocumentDownload: [],
                visibleDownloadChecklist: false,
                restUploadRunning: false,
                listOfDocumentUpload: [],
                visibleUploadChecklist: false,
                praticaDaCorreggere: false,
                showMapInfo: false,
                mapInfo: ""
            }

            if (self.richiestePostVendita.viewIndex == 0) {
                self.richiestePostVendita.viewIndex = 1300;
            }

            if (self.richiestePostVendita.status === "PV120") {
                self.supportModel.praticaDaCorreggere = true;
            }

            var contratti = [];
            if (self.richiestePostVendita.metadata.autorizzazioneComunale.contratti.length == 0) {
                self.richiestePostVendita.metadata.ctrRichiestaList.forEach(function (contratto) {
                    contratti.push(Contratti.build({
                        numero: contratto.numeroContratto,
                        modulo: contratto.numeroModulo,
                        selected: true,
                        codProdotto: contratto.codProdotto
                    }));
                });

                self.richiestePostVendita.metadata.autorizzazioneComunale.contratti = contratti;
            }

            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1' || self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK2' || self.richiestePostVendita.readOnly) {
                popolateCheckListDownload();
                popolateCheckListUpload();
            }

            retrieveStepInfo();
        };

        self.allegatiChange = function (value) {
            if (self.richiestePostVendita.metadata.autorizzazioneComunale.allegati.length > 0) {
                self.richiestePostVendita.metadata.autorizzazioneComunale.allegati.push(value);
            } else {
                self.richiestePostVendita.metadata.autorizzazioneComunale.allegati[0] = value;
            }
        }

        self.validityPage = function (validity) {
            self.munAuthComponent = validity;
        }

        self.nextValidity = function () {
            return self.munAuthComponent;
        }

        self.backValidity = function () {
            return (self.getWizardMap(self.richiestePostVendita.viewIndex) !== 'PAI1') || self.richiestePostVendita.readOnly ? true : false;
        }

        self.closeModal = function () {
            $modalService.closeModal("suspendInstance");
        }

        self.next = function () {
            self.supportModel.nextStep = true;
            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PAI1') {
                $RichiestePostVenditaService
                    .generateDocumentsPv(RichiestePostVendita.build(self.richiestePostVendita))
                    .then(function (response) {
                        if (response.success) {
                            $RichiestePostVenditaService
                                .nextStep(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                                .then(function (response) {
                                    self.supportModel.nextStep = false;
                                    self.richiestePostVendita = response;

                                    if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1' || self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK2') {
                                        retrieveStepInfo();
                                        popolateCheckListDownload();
                                        popolateCheckListUpload();
                                    }

                                }).catch(function (error) {
                                    console.log(error);
                                    self.supportModel.nextStep = false;
                                });
                        } else {
                            self.supportModel.nextStep = false;
                        }
                    }).catch(function (error) {
                        console.log(error);
                        self.supportModel.nextStep = false;
                        self.enabledLoader = false;
                    });
            } else if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1' || self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK2') {
                $RichiestePostVenditaService
                    .submitAutComunale(self.richiestePostVendita.metadata.autorizzazioneComunale, self.richiestePostVendita.id, self.richiestePostVendita.viewIndex,
                        self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                    .then(function (response) {
                        self.supportModel.nextStep = false;
                        $location.path('/');
                    }).catch(function (error) {
                        console.log(error);
                        self.supportModel.nextStep = false;
                    });
            }
        }

        self.back = function () {
            if (self.richiestePostVendita.readOnly) {
                $location.path('/');
            } else {
                $RichiestePostVenditaService
                    .backStep(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                    .then(function (response) {
                        self.supportModel.nextStep = false;
                        self.richiestePostVendita = response;
                        retrieveStepInfo();
                    }).catch(function (error) {
                        console.log(error);
                        self.supportModel.nextStep = false;

                    })
            }
        }

        self.sospendi = function () {
            $RichiestePostVenditaService
                .suspendInstance(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                .then(function () {
                    $location.path('/');
                    $modalService.closeModal("suspendInstance");
                })
        }

        var popolateCheckListDownload = function () {
            self.supportModel.restDownloadRunning = true;
            $arcService.downloadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.supportModel.listOfDocumentDownload = response.listDocuments;
                    self.supportModel.visibleDownloadChecklist = response.visible;
                    self.supportModel.restDownloadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restDownloadRunning = false;
                })
        }

        var popolateCheckListUpload = function () {
            self.supportModel.restUploadRunning = true;
            $arcService.uploadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.supportModel.listOfDocumentUpload = response.listDocuments;
                    self.supportModel.visibleUploadChecklist = response.visible;
                    self.message = response.message;
                    self.supportModel.restUploadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.supportModel.restUploadRunning = false;
                })
        }

        self.getWizardMap = function (viewIndex) {
            if (
                $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                })
            ) {
                return $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                }).viewName;
            }
        };

        var retrieveStepInfo = function () {
            self.clearLabelInfo = true;
            $RichiestePostVenditaService
                .getStepInfo(self.richiestePostVendita.id, self.richiestePostVendita.viewIndex)
                .then(function (response) {
                    if (response.success) {
                        self.supportModel.showMapInfo = response.showBeMessage;
                        self.supportModel.mapInfo = response.message;
                        self.enabledLoader = false;
                    }
                    self.clearLabelInfo = false;
                })
                .catch(function (error) {
                    console.log(error);
                    self.enabledLoader = false;
                    self.clearLabelInfo = false;
                });
        }
    }
});